/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Task } from './task';
import type { ExamAttemptReportResponseGradingConfigSnapshot } from './examAttemptReportResponseGradingConfigSnapshot';

/**
 * Archived tasks and grading snapshot for one earlier graded exam.
 */
export interface ExamAttemptReportResponse {
  tasks: Task[];
  gradingConfigSnapshot?: ExamAttemptReportResponseGradingConfigSnapshot;
}
